"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const encoding_1 = require("./encoding");
const errors_1 = require("./errors");
const http_1 = require("./http");
const navigator_1 = require("./navigator");
const authid_1 = require("./authid");
const encoding = { base64EncodeUrl: encoding_1.base64EncodeUrl, base64ToBuffer: encoding_1.base64ToBuffer, bufferToBase64: encoding_1.bufferToBase64 };
const errors = { SDKError: errors_1.SDKError, NavigatorError: errors_1.NavigatorError, getErrorMessageByCode: errors_1.getErrorMessageByCode };
const http = { post: http_1.post };
const navigator = { getCredential: navigator_1.getCredential, createCredential: navigator_1.createCredential, convertCredentialDescriptor: navigator_1.convertCredentialDescriptor };
const utils = {
    encoding,
    errors,
    http,
    navigator,
    authidIframeHandler: authid_1.authidIframeHandler
};
exports.default = utils;
//# sourceMappingURL=index.js.map